import { Component, Input } from '@angular/core';
import { ManageTransactionDataService } from '../../../../services/manage-transaction-data.service';
import { SessionService } from '../../../../services/session.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'vm-contact-us-priority-shell',
  templateUrl: './contact-us-priority-shell.component.html',
})
export class ContactUsPriorityShellComponent {
  @Input() strapiUID = 'angular-contact-us-priority';
  @Input() routerLinkText = 'Back';
  @Input() routerLinkHref = '../ivr-static';
  @Input() chatbotId = 'faultsbuttonnew';
  @Input() ivrPriority = true;
  @Input() enableBackLink = true;

  nextAction: string;

  constructor(
    private manageTransactionDataService: ManageTransactionDataService,
    private sessionService: SessionService
  ) {}

  onContinue(nextAction) {
    this.nextAction = nextAction?.uid || nextAction?.id;
  }

  openCallUsDialog() {
    this.sessionService.getSessionData().subscribe((sessionResponse) => {
      const uuid = uuidv4();
      const nextAction = this.nextAction || 'Advised to call';
      const actionCode = 'NEW_IVR_PRIORITY_POSITION';
      this.manageTransactionDataService.priorityCall(
        uuid,
        `FLT:${actionCode}`,
        nextAction,
        sessionResponse?.angularPublicSession?.tid
      );
    });
  }
}
